export class Car {
    constructor(public vin: any, public placas: any, public motor: any){
    }
  }